import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function ChooseEngagementActions() {
    return (
        <OnboardingBody title='Choose your actions' statusText='Engagement bar'>
            <p>
                Configure, enable, and rearrange engagement bar actions to align with your needs and
                business objectives.
            </p>
        </OnboardingBody>
    );
}
